import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as elementStyles from "@universityofmaryland/web-styles-library/element";
import { pin } from "@universityofmaryland/web-icons-library/location";
import { calendar, clock } from "@universityofmaryland/web-icons-library/calendar";
const MakeDetailItem = (props) => {
  const { icon, text, isThemeDark } = props;
  const iconElement = new ElementBuilder("span").withHTML(icon).build();
  const textElement = new ElementBuilder("span").withHTML(text).build();
  return new ElementBuilder("p").styled(
    elementStyles.event.meta.composeItem({
      theme: isThemeDark ? "dark" : "light"
    })
  ).withChildren(iconElement, textElement).build();
};
const createDayText = ({
  startDayOfWeek,
  startMonth,
  startDay,
  endDayOfWeek,
  endDay,
  endMonth,
  isMultiDay = false,
  isThemeDark
}) => {
  let text = `${startDayOfWeek}. ${startMonth} ${startDay}`;
  if (isMultiDay) {
    text = `${text} - ${endDayOfWeek}. ${endMonth} ${endDay}`;
  }
  return MakeDetailItem({
    icon: calendar,
    text,
    isThemeDark
  });
};
const createTimeText = ({
  startTime,
  endTime,
  isThemeDark
}) => {
  let text = startTime;
  if (startTime != endTime) {
    text = `${text} - ${endTime}`;
  }
  return MakeDetailItem({
    icon: clock,
    text,
    isThemeDark
  });
};
const createDateRow = (props) => {
  const { showTime = true, startMonth, startDay, endDay, endMonth } = props;
  const isMultiDay = startDay != endDay || startMonth != endMonth;
  const dateElement = createDayText({ ...props, isMultiDay });
  const element = new ElementBuilder().withClassName("event-meta-date-row").withChild(dateElement);
  if (showTime) {
    element.withChild(createTimeText({ ...props }));
  }
  return element.build();
};
const createEventMeta = (props) => {
  const { location, isThemeDark } = props;
  const dateRow = createDateRow(props);
  const wrapper = new ElementBuilder().styled(elementStyles.event.meta.wrapper).withChild(dateRow);
  if (location && location.length > 0) {
    wrapper.withChild(
      MakeDetailItem({ ...props, icon: pin, text: location[0].title })
    );
  }
  const wrapperModel = wrapper.build();
  return new ElementBuilder().styled(elementStyles.event.meta.container).withChild(wrapperModel).build();
};
export {
  createEventMeta
};
//# sourceMappingURL=meta.js.map
